"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedIcon = void 0;

var _element = require("@wordpress/element");

var _blockEditor = require("@wordpress/block-editor");

var _icons = require("@wordpress/icons");

/**
 * WordPress dependencies
 */
const sharedIcon = (0, _element.createElement)(_blockEditor.BlockIcon, {
  icon: _icons.gallery
});
exports.sharedIcon = sharedIcon;
//# sourceMappingURL=shared-icon.js.map